// extracted by mini-css-extract-plugin
module.exports = {"message":"MessageCloud_message__13Fso"};